import type { Timestamp } from 'firebase/firestore';

// ----------------------------------------------------------------------

/**
 * Eine User-Gruppe (z.B. Team / Abteilung). Frei definierbar und unabhängig
 * von der Rolle (siehe `auth/roles.ts`). Ein User kann in mehreren Gruppen
 * sein.
 */
export type UserGroup = {
  id: string;
  name: string;
  description?: string;
  createdAt?: Timestamp | null;
};

/**
 * Firestore-Collection für die Gruppen-Definitionen.
 * Die Group-ID entspricht der Doc-ID in dieser Collection.
 */
export const USER_GROUPS_COLLECTION = 'user_groups';

/**
 * Feldname auf dem User-Dokument (`users/{uid}.groups`) – Array von Group-IDs.
 */
export const USER_GROUPS_FIELD = 'groups';

/**
 * Normalisiert ein beliebiges Eingabe-Array zu einer eindeutigen, sortierten
 * Liste von Group-IDs (string[]). Filtert leere Werte / Duplikate raus.
 */
export function normalizeGroupIds(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const ids = value.filter((v): v is string => typeof v === 'string' && v.trim().length > 0);
  return Array.from(new Set(ids)).sort();
}

/**
 * Normalisiert einen Gruppen-Namen für die UI (trimmt, kollabiert Whitespace).
 */
export function normalizeGroupName(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}
